import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {FueltaxService} from '../../service/fueltax/fueltaxService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class FueltaxPrefForm extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var fueltaxPrefGrid = this;
		setTimeout(function(){
			fueltaxPrefGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var fueltaxPrefGrid = this;
		
		var toolbarForm = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [								
				{										
					tag: 'vaadin-combo-box',
					itemid: 'groupId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 350px;',
					label: 'Unit Group',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'helper-text': 'This shows what the preference the groups has; if no override then it will show the default.',
					postinit: function(combo) {						
						
						UnitService.getUnitGroupService().getUnitGroups().then(function(groups){	
							var lookups = [];
							groups.data.forEach(function(group){
								lookups.push({
									code: group.unitGroupId,
									description: group.groupName
								});
							});							
							combo.items = lookups;						
						});
						
					},
					placeHolder: 'Company Defaults',
					listeners: {
						change: function() {
							actionLoadPreferences();
						}
					}
				},
				{
					tag: 'hr'
				}
			]
		});				
		
		var taxNumbers = [];
		
		var taxNumberToolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['FUELTAX_PREFERENCES:WRITE'],
					children: [
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function () {
							actionAddEditTaxNumber();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['FUELTAX_PREFERENCES:WRITE'],
					children: [
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function () {
							actionAddEditTaxNumber(taxNumberGrid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children: [
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							disabled: true,
							theme: 'error primary',
							'class': 'spacer-toolbar-item',
							permissions: ['FUELTAX_PREFERENCES:WRITE'], //this is intentional							
							children: [
								ElementUtil.makeIcon('vaadin:trash', 'Remove')
							],
							listeners: {
								click: function () {
									actionDeleteTaxNumber(taxNumberGrid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});

		var taxNumberGrid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': true,
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed': function (event) {
						if (event.detail && event.detail.value) {
							taxNumberGrid.currentSortField = event.target.path;
							taxNumberGrid.currentSortDirection = event.detail.value.toUpperCase();
						}
					}
				}
			},
			children: [
				{
					path: 'type',
					header: 'Type',
					width: '7em'
				},
				{
					path: 'typeDescription',
					header: 'Description',
					width: '9em'
				},
				{
					path: 'value',
					header: 'Value',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function (event) {
					const item = event.detail.value;
					taxNumberGrid.selectedItems = item ? [item] : [];
					if (taxNumberGrid.selectedItems.length > 0) {
						ElementUtil.query(taxNumberToolbar, 'edit').disabled = false;
						ElementUtil.query(taxNumberToolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(taxNumberToolbar, 'edit').disabled = true;
						ElementUtil.query(taxNumberToolbar, 'delete').disabled = true;
					}
				}
			}
		});			
	
		var formPanel = ElementUtil.create({
			tag: 'dl-form-panel',
			slot: 'primary',		
			children: [	
				{
					tag: 'div',
					style: 'padding: 20px;',
					children: [
						{
							tag: 'vaadin-form-layout',
							children: [
								{
									tag: 'vaadin-combo-box',
									itemid: 'stateProvCodeCB',
									label: 'Ifta Tax Jurisdiction State/Providence',
									name: 'iftaTaxJurisState',
									'item-value-path': 'code',
									'item-label-path': 'description',
									postinit: function (combo) {
										Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-combo-box',
									label: 'Reporting Default Units of Measure',
									name: 'reportDefaultUOM',
									'item-value-path': 'code',
									'item-label-path': 'description',
									postinit: function (combo) {
										Service.getLookupService().getLookupValues('MeasurementSystem').then(function (data) {
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-combo-box',
									label: 'New York Tax Method',
									name: 'newYorkTaxMethod',
									'item-value-path': 'code',
									'item-label-path': 'description',
									postinit: function (combo) {
										Service.getLookupService().getLookupValues('TaxMethodType').then(function (data) {
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-combo-box',
									label: 'Oregon Reporting Interval',
									name: 'oregonReportingTimeInterval',
									'item-value-path': 'code',
									'item-label-path': 'description',
									postinit: function (combo) {
										Service.getLookupService().getLookupValues('ReportingTimeInterval').then(function (data) {
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-combo-box',
									label: 'New York Reporting Interval',
									name: 'newyorkReportingTimeInterval',
									'item-value-path': 'code',
									'item-label-path': 'description',
									postinit: function (combo) {
										Service.getLookupService().getLookupValues('ReportingTimeInterval').then(function (data) {
											combo.items = data;
										});
									}
								}
							]
						},
						{
							tag: 'br'
						},
						{
							tag: 'fieldset',
							colspan: 2,
							children: [
								{
									tag: 'legend',
									innerHTML: 'MPG Override Preference'
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-number-field',
											label: 'Min MPG',
											name: 'mpgMinOverride',											
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',
											label: 'Min MPG Override Value',
											name: 'mpgMinOverrideDefault',
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',
											label: 'Between Min MPG',
											name: 'mpgBetweenMinOverride',
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',
											label: 'Between Max MPG',
											name: 'mpgBetweenMaxOverride',
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',
											label: 'Between Override Value',
											name: 'mpgBetweenOverrideDefault',
											min: 0,
											max: 1000
										},
										{
											tag: 'div'
										},
										{
											tag: 'vaadin-number-field',
											label: 'Max MPG',
											name: 'mpgMaxOverride',
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',
											label: 'Max MPG Override Value',
											name: 'mpgMaxOverrideDefault',
											min: 0,
											max: 1000
										}
									]
								}
							]
						},
						{
							tag: 'br'
						},
						{
							tag: 'dl-section-title',
							title: 'Tax Numbers',
							colspan: 2,
							style: 'margin-top: 20px;'
						},
						{
							tag: 'div',
							style: 'height: 300px;',
							colspan: 2,
							children: [
								{
									tag: 'dl-flex-layout',
									children: [
										taxNumberToolbar,
										taxNumberGrid
									]
								}
							]
						}
					]
				},
				{
					tag: 'vaadin-form-layout',
					children: [
						{
							tag: 'hr',
							colspan: 2
						},
						{
							tag: 'div',
							style: 'text-align: center;',
							colspan: 2,
							defaults: {
								tag: 'vaadin-button'
							},
							children: [
								{
									theme: 'primary',
									children: [
										ElementUtil.makeIcon('vaadin:database', ' Save')
									],
									listeners: {
										click: function () {
											actionSavePreferences();
										}
									}
								}
							]
						}
					]
				},
				{
					tag: 'br'
				}
			]
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarForm,
				formPanel
			]
		});		
		fueltaxPrefGrid.append(flexLayout);		
			
		//load prefs
		var actionLoadPreferences = function(unitGroupId) {
			
			var groupId;
			var unitGroupCB = ElementUtil.query(toolbarForm, 'groupId');	
			if (unitGroupCB) {
				groupId = unitGroupCB.value;
			}			
			var loadMask = flexLayout.showLoading();
			FueltaxService.getFuelTaxPrefService().getFuelTaxPref(groupId).then(function(pref){
				loadMask.remove();
				
				if (pref.mpgOverridePreference) {
					pref.mpgMaxOverride = pref.mpgOverridePreference.mpgMaxOverride;
					pref.mpgMaxOverrideDefault = pref.mpgOverridePreference.mpgMaxOverrideDefault;
					pref.mpgMinOverride = pref.mpgOverridePreference.mpgMinOverride;
					pref.mpgMinOverrideDefault = pref.mpgOverridePreference.mpgMinOverrideDefault;
					pref.mpgBetweenMaxOverride = pref.mpgOverridePreference.mpgBetweenMaxOverride;
					pref.mpgBetweenMinOverride = pref.mpgOverridePreference.mpgBetweenMinOverride;
					pref.mpgBetweenOverrideDefault = pref.mpgOverridePreference.mpgBetweenOverrideDefault;
				}
				
				formPanel.load(pref, {
					refreshComponents: true
				});
				taxNumbers = pref.taxNumberViews.slice();
				actionRefreshTaxNumbers();				
			});						
		};
		actionLoadPreferences();
		
		var actionRefreshTaxNumbers = function() {			
			taxNumberGrid.items = taxNumbers.slice();				
		};
		
		var actionAddEditTaxNumber = function (taxNumber) {

			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: taxNumber ? 'Edit Tax Number' : 'Add Tax Number',
				icon: 'vaadin:edit',
				width: 600,
				height: 250,
				listeners: {
					ready: function () {
						addEditWin.show();

						
						var formPanelTaxNumber = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-combo-box',											
											itemId: 'type',
											name: 'type',
											label: 'Type',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											required: true,
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('FuelTaxTaxNumberType').then(function (data) {

													var available = [];
													var existing = {};
													taxNumbers.forEach(function(item) {
														existing[item.type] = true;
													});
													data.forEach(function(item){
														if (!existing[item.code] || (taxNumber && taxNumber.type === item.code)) {
															available.push(item);
														}
													});

													combo.items = available;

												});
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'vaadin-text-field',
											name: 'value',
											label: 'Value',
											required: true,
											maxLength: 255
										}
									]
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {

															if (formPanelTaxNumber.isValid()) {
																var data = formPanelTaxNumber.getData();

																var fieldCB = ElementUtil.query(formPanelTaxNumber, 'type');
																if (fieldCB.selectedItem) {
																	data.typeDescription = fieldCB.selectedItem.description;
																}

																if (taxNumber) {
																	taxNumber.type = data.type;
																	taxNumber.typeDescription = data.typeDescription;
																	taxNumber.value = data.value;																	
																} else {
																	taxNumbers.push(data);
																}
																actionRefreshTaxNumbers();
																addEditWin.close();
															}

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}								
							]
						});

						addEditWin.addToContentElement(formPanelTaxNumber);

						if (taxNumber) {
							formPanelTaxNumber.load(taxNumber);
						}
					}
				}
			});

		};
		
		var actionDeleteTaxNumber = function(taxNumber) {
			var numbersToKeep = [];
			taxNumbers.forEach(function (item) {
				var keep = true;
				if (item.type === taxNumber.type) {
					keep = false;
				}
				if (keep) {
					numbersToKeep.push(item);
				}
			});
			taxNumbers = numbersToKeep;
			actionRefreshTaxNumbers();
		};
		
		var actionSavePreferences = function() {
			
			formPanel.submitForm({
				preSubmit: function (data) {
					var stateCB = ElementUtil.query(formPanel, 'stateProvCodeCB');

					if (stateCB.selectedItem) {
						data.iftaTaxJurisCountry = stateCB.selectedItem.country;
					} else {
						delete data.iftaTaxJurisState;
					}
					data.taxNumbers = taxNumbers;
					
					if (data.mpgMaxOverride || 
						data.mpgMaxOverrideDefault ||
						data.mpgMinOverride ||
						data.mpgMinOverrideDefault ||
						data.mpgBetweenMaxOverride ||
						data.mpgBetweenMinOverride ||
						data.mpgBetweenOverrideDefault) {
						
						data.mpgOverridePreference = {
							mpgMaxOverride: data.mpgMaxOverride,
							mpgMaxOverrideDefault: data.mpgMaxOverrideDefault,
							mpgMinOverride: data.mpgMinOverride,
							mpgMinOverrideDefault: data.mpgMinOverrideDefault,
							mpgBetweenMaxOverride: data.mpgBetweenMaxOverride,
							mpgBetweenMinOverride: data.mpgBetweenMinOverride,
							mpgBetweenOverrideDefault: data.mpgBetweenOverrideDefault
						};
					} 
					return data;
				},
				actualCall: function (data) {
					var unitGroupCB = ElementUtil.query(toolbarForm, 'groupId');					
					if (unitGroupCB) {
						data.unitGroupId = unitGroupCB.value;
					}
					return FueltaxService.getFuelTaxPrefService().saveFuelTaxPref(data);
				},
				success: function (data, responseData) {
					window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
						theme: 'success',
						position: 'top-stretch'
					});
					
				}
			});					
			
		};
		
	}
	
}
customElements.define('dl-fueltax-pref-form', FueltaxPrefForm);

